import { type ComponentProps } from 'react'

import { cn } from '@/lib/utils'

export const Radio = ({
  className,
  label,
  ...props
}: {
  className?: string
  label?: string
} & ComponentProps<'input'>) => {
  return (
    <label className={cn('flex cursor-pointer select-none flex-col items-center gap-1', className)}>
      <span className="flex items-center justify-center">
        <input
          type="radio"
          className="mr-2 inline-flex min-h-5 min-w-5 cursor-pointer border border-black bg-white accent-black"
          {...props}
        />
        {label}
      </span>
    </label>
  )
}
